<template>
  <section>
    <div class="container">
      <p class="last-update">
        {{ $t("intro_last_update") }}: {{ $t("intro_last_update_date") }}
      </p>
      
      <p class="text-large">
        <i18n tag="p" path="intro_post_election">
          <template v-slot:link_inwt_blog_analyse>
            <a href="https://www.inwt-statistics.de/blog-artikel-lesen/bundestagswahl-2021-wie-gut-waren-unsere-wahlprognosen.html" target="_blank">
              {{ $t("other_here")}}
            </a>
          </template>
          <template v-slot:link_inwt_blog>
            <a href="https://www.inwt-statistics.de/blog.html" target="_blank">
              INWT Statistics Blog
            </a>
          </template>
        </i18n>
      </p>
    </div>

    <div class="container">
      <hr class="rounded" />
    </div>

    <div class="container">
      <p class="last-forecast">
        {{ $t("intro_last_forecast") }}: {{ $t("intro_last_forecast_date") }}
      </p>

      <h2>
        {{ $t("intro_title") }}
      </h2>

      <i18n path="intro_text" tag="p" class="text-large">
        <template v-slot:forecasts_for_election>
          <b>{{ $t("other_forecasts_for_election") }}</b>
        </template>
        <template v-slot:our_model>
          <router-link :to="'/' + $i18n.locale + '/faq#faq-1'">{{
            $t("other_our_model")
          }}</router-link>
        </template>
      </i18n>

      <i18n path="intro_github" tag="p" class="text-large">
        <template v-slot:link_github>
          <a
            href="https://github.com/INWTlab/lsTerm-election-forecast/"
            target="_blank"
          >
            {{ $t("other_github") }}
          </a>
        </template>
      </i18n>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    lastUpdate() {
      return this.$store.getters.lastUpdate;
    },
  },
  created() {
    this.$store.dispatch("getLastUpdate");
  },
};
</script>


<style>
hr.rounded {
  border: 4px solid var(--red-primary);
  border-radius: 4px;
  background: var(--red-primary);
}

.last-update {
  font-size: 1.25rem;
  font-weight: 800;
  font-style: italic;
}

.last-forecast {
  font-size: 1.25rem;
  font-weight: 800;
  font-style: italic;
  margin-bottom: 4em;
}
</style>